export default {
  StartStep: {
    CreateQuote: 'Tap here to get a custom price quote',
  },
  TitleCard: {
    Title: 'Supporting your family\'s needs.',
    Description: 'Reliable, consistent, and compassionate senior care designed for the long term. We specialize in matching your family with a dedicated caregiver supported by our Care Team, giving you the peace of mind to stop managing care and start being a family again.',
  },
  HowWorksCard: {
    Title: 'How CareQuilt works',
    DescriptionBeforeHighlight: 'We focus on',
    DescriptionHighlight: 'recurring care',
    DescriptionAfterHighlight: 'because consistency leads to better health outcomes and stronger bonds with your caregiver.',
    StepSetRecurringScheduleTitle: 'Set a recurring schedule',
    StepSetRecurringScheduleDescription: 'Choose when you want help and understand the cost of care.',
    StepIdentifyCareNeedsTitle: 'Identify care needs',
    StepIdentifyCareNeedsDescription: 'Create a plan that ensures your loved one\'s needs are met. Meet with your Care Team to review or ask questions before getting started.',
    StepPerfectMatchTitle: 'The perfect match',
    StepPerfectMatchDescription: 'Review 3-5 caregivers who are a fit for your family. Meet your caregiver before committing to anything.',
    StepOngoingSupportTitle: 'Ongoing support',
    StepOngoingSupportDescription: 'Our in-house Care Operations Team manages the logistics so the care always runs smoothly.',
    MutualOptInTitle: 'The "mutual opt-in" advantage',
    MutualOptInBeforeHighlight: 'Our model is "mutual opt-in," meaning families choose their caregivers, and caregivers also choose the families they work with. This ensures that every person in the home wants to be there, creating a deeper level of trust and commitment. To ensure long-term success, we recommend a',
    MutualOptInHighlight: '3-hour minimum per visit',
    MutualOptInAfterHighlight: 'This makes the schedule more sustainable for caregivers and allows enough time for truly meaningful engagement and quality care for your loved one.',
  },
  ScopeCard: {
    Title: 'The scope of care: what a caregiver does',
    DescriptionBeforeHighlight: 'Our caregivers typically operate within the',
    DescriptionHighlight: 'Personal Support Worker (PSW)',
    DescriptionMiddle: 'scope of practice. They are experts in',
    DescriptionTerm: '"Activities of Daily Living" (ADLs).',
    CanDoTitle: 'What they can do',
    CannotDoTitle: 'What they cannot do',
    CanDoPersonalCareTitle: 'Personal care',
    CanDoPersonalCareDescription: 'Bathing, dressing, and grooming.',
    CanDoMobilityTitle: 'Mobility',
    CanDoMobilityDescription: 'Assistance with transfers and walking, getting around their living space.',
    CanDoHomeSupportTitle: 'Home support',
    CanDoHomeSupportDescription: 'Light housekeeping, laundry, dishes.',
    CanDoNutritionTitle: 'Nutrition',
    CanDoNutritionDescription: 'Meal planning, prep, and feeding assistance.',
    CanDoCompanionshipTitle: 'Companionship',
    CanDoCompanionshipDescription: 'Meaningful engagement and outings.',
    CanDoErrandsTitle: 'Errands',
    CanDoErrandsDescription: 'Run errands with or for your loved one.',
    CanDoMedicationRemindersTitle: 'Medication reminders',
    CanDoMedicationRemindersDescription: 'Timed reminders to take medication (strictly cannot dispense/administer medications).',
    CanDoTransportationTitle: 'Transportation',
    CanDoTransportationDescription: 'Accompanying on public or private transportation (strictly cannot drive a vehicle).',
    CannotDoMedicalProceduresTitle: 'Medical procedures',
    CannotDoMedicalProceduresDescription: 'Injections, sterile wound care, or tube feeding.',
    CannotDoAssessmentsTitle: 'Assessments',
    CannotDoAssessmentsDescription: 'Diagnosing new medical conditions or changing prescriptions.',
    CannotDoHeavyLaborTitle: 'Heavy labor',
    CannotDoHeavyLaborDescription: 'Deep cleaning, snow shoveling, yard work, or moving furniture.',
    CannotDoProfessionalServicesTitle: 'Professional services',
    CannotDoProfessionalServicesDescription: 'Legal or financial advice.',
  },
};
